export default "__VITE_ASSET__uPkTyX1j__"